/**
 * @description
 * headers to dispatch request batch detail
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'dispatch-request-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'folio',
        value: 'sl_sale_number',
    },
    {
        text: 'rut',
        value: 'sl_customer_rut',
        format: 'rut',
    },
    {
        text: 'cliente',
        value: 'sl_customer_alias_name',
    },
    {
        text: 'vendedor',
        value: 'g_seller_user_full_name',
    },
    {
        text: 'condición de pago',
        value: 'pch_payment_condition_type',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                disabled: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'estado',
        value: 'g_state_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    por_despachar: 'accent lighten-3',
                    facturada: 'indigo lighten-3',
                    confirmada: 'secondary lighten-3',
                    despachada: 'secondary lighten-3',
                    recepcionada_parcialmente: 'info lighten-3',
                    recepcionada: 'success lighten-3',
                    no_recepcionada: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
    },
    {
        text: 'Facturacion',
        value: 'bill_state_str',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                disabled: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'creación',
        value: 'created_at',
        sortable: true,
        align: 'right',
        format: 'datetime',
    },
    {
        text: 'modificación',
        value: 'updated_at',
        sortable: true,
        align: 'right',
        format: 'datetime',
        width: '10%',
    },
]
